import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faCalculator as fasCalculator } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import headerImage from "@img/calculator/embed/personal_loans_scoring/header.png";
import { Button, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Alert, Card } from "react-bootstrap";

export class Step1 extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Img
					src={headerImage}
					variant="top"
					width="350"
					height="155"
					alt="Mennyi személyi kölcsönt kaphatok?"
				/>
				<Card.Body>
					<div className="h4 text-center my-2">Perceken belül megtudhatod, hogy:</div>
					<Alert variant="info">
						<List itemStyle="question-circle" variant="success" className="mb-0">
							<List.Item>
								Mennyi személyi kölcsönt <strong>vehetsz fel</strong>
							</List.Item>
							<List.Item>
								Milyen <strong>feltételekkel</strong>
							</List.Item>
							<List.Item>
								Mennyi havi <strong>törlesztőrészlettel</strong>
							</List.Item>
						</List>
					</Alert>
					<div>
						<strong>Részletes adatokat kérünk</strong> és ennek fejében{" "}
						<strong>+/-10%-os pontossággal</strong> jelezzük a felvehető hitel összegét és a havi törlesztő
						összeget!
					</div>
					<div className="font-weight-bold my-3 w-100 text-center">
						<mark className="bg-primary text-white">Ne feledd, ez több mint egy kalkulátor!</mark>
					</div>
					<div>
						Adataid megadása után <strong>szakértőnk megválaszolja</strong> minden kérdésedet és{" "}
						<strong>segít az ügyintézésben</strong> is.
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasCalculator} />}>
						Kalkuláció indítása
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
